import { useTranslation } from 'next-i18next';
import React from 'react';
import styled from 'styled-components';
import { sx2CssThemeFn } from '@hotelplan/libs.sx';
import CurrentHotelPinIcon from 'components/domain/map/CurrentHotelPinIcon';
import BestsellerProductPinIcon from 'components/domain/map/MapProductPin/BestsellerPinIcon';

const LegendItems = styled.ul(
  sx2CssThemeFn({
    display: 'flex',

    li: {
      display: 'flex',
      alignItems: 'center',
      mr: 4,

      '.label': {
        pl: 1,
        fontSize: '14px',
        fontWeight: 'bold',
      },
    },
  })
);

const PdpMapLegend: React.FC = () => {
  const [t] = useTranslation('pdp');

  return (
    <LegendItems>
      <li>
        <BestsellerProductPinIcon />
        <p className="label">{t('pdp:map.legend.bestseller')}</p>
      </li>
      <li>
        <CurrentHotelPinIcon />
        <p className="label">{t('pdp:map.legend.currentHotel')}</p>
      </li>
    </LegendItems>
  );
};

export default PdpMapLegend;
